export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14526.02295b88.jpg";